(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/thunks/pay.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/thunks/pay.js');
"use strict";


const {
  makePayment
} = svs.gamePackage.pay;
const {
  updateBalance
} = svs.gamePackage.redux.accountSlice.actions;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const pay = () => dispatch => {
  if (isSelfService) {
    const {
      sizes,
      activeIndex
    } = svs.gamePackage.redux.store.getState().gamePackage;
    svs.gamePackage.selfservice.addToCart({
      productFlag: svs.gamePackage.data.packageConfig.title.toLowerCase(),
      wagers: svs.gamePackage.data.packageConfig.selfserviceIds[activeIndex],
      cost: sizes[activeIndex].price
    });
  } else {
    makePayment({
      onSuccess: _ref => {
        let {
          newBalance: balance
        } = _ref;
        dispatch(updateBalance({
          balance
        }));
      }
    });
  }
};
svs.gamePackage.redux.thunks.pay = pay;

 })(window);